import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=b2cebf9c&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=b2cebf9c&prod&lang=scss&scoped=true&"
import style1 from "./Menu.vue?vue&type=style&index=1&id=b2cebf9c&prod&vars=%7B%20fontColor%20%7D&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cebf9c",
  null
  
)

export default component.exports